import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex flex-col max-h-screen w-full gap-7 overflow-y-scroll pb-32" }
const _hoisted_2 = { class: "mx-auto px-2" }
const _hoisted_3 = { class: "flex flex-col bg-white shadow-base py-10 mb-[60px] rounded-3xl px-3" }
const _hoisted_4 = { class: "flex flex-col gap-5" }
const _hoisted_5 = { class: "max-w-[300px]" }
const _hoisted_6 = { class: "text-xl font-bold text-left" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "w-full" }
const _hoisted_9 = {
  key: 0,
  class: "flex flex-col gap-8 w-full pt-3"
}
const _hoisted_10 = { class: "flex justify-center gap-5" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("strong", null, " Cancel ", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("strong", null, " Save ", -1)
const _hoisted_13 = { class: "flex mb-[60px] px-2" }
const _hoisted_14 = {
  key: 0,
  class: "px-10 py-3 h-12 font-bold text-error bg-error bg-opacity-20 w-full rounded-base"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("strong", null, "Exit", -1)
const _hoisted_16 = {
  key: 2,
  class: "px-10 h-12 font-bold w-full text-primary-violet pt-3"
}

import { onMounted, computed, ref, watch } from "vue"
  import { useCultureKitStore } from "@/store/cultureKit"
  import { useRoute, useRouter } from "vue-router"
  import { useResourcesStore } from "@/store/resources"
  import { parse, differenceInSeconds, isValid } from "date-fns"
  import jwt from "@/utils/jwt"
  import { modalController, toastController } from "@ionic/vue"

  // components
  import BannerTemplate from "@/components/culture-kit/BannerTemplate.vue"
  import WbButton from "@/components/template/buttonTemplate.vue"
  import WbTextArea from "@/components/template/TextAreaTemplate.vue"
  import verifySubmit from "@/components/culture-kit/verifySubmit.vue"

  // image
  import BannerImage from "@/assets/images/question/thought-leadership-banner.png"

  // initializations
  
export default /*#__PURE__*/_defineComponent({
  __name: 'ThoughtLeadership',
  setup(__props) {

  const nbf = jwt.generateNBF()
  const store = useCultureKitStore()
  const resourcesStore = useResourcesStore()
  const route = useRoute()
  const router = useRouter()
  const confirmation = ref(false)
  const expired = ref(false)
  const editMode = ref(false)
  const dateRemain = ref<string>("")
  const banner = computed(() => ({
    title: dateRemain.value,
    description: expired.value ? "" : "Question of the week is here! Can we count on you to share your thoughts on the topic(s) here?",
    topicList: expired.value ? [] : resourcesStore.thoughtLeadership.tags,
    image: BannerImage,
    expired: expired.value,
  }))

  /**
   * replace &nbsp; with whitespace
   */
  const replacenbsp = (val: string) => val.replaceAll("&nbsp;", " ")

  /**
   * get time remaining
   */
  const getTimeRemain = () => {
    if (!expired.value) {
      const deadline = parse(resourcesStore.thoughtLeadership.date_expiry, "dd/MM/yy HH:mm:ss", new Date())
      let toReturn = ""
      if (isValid(deadline)) {
        const difference = differenceInSeconds(deadline, new Date())
        const days = Math.floor(difference / (60 * 60 * 24))
        const hours = Math.floor((difference % (60 * 60 * 24)) / 3600)
        const minutes = Math.floor((difference % (60 * 60)) / 60)
        const seconds = Math.floor(difference % 60)
        if (hours < 0 && minutes < 0 && seconds < 0) {
          expired.value = true
          return "This topic has already ended."
        }
        const dd = days < 10 ? `0${days}` : days
        const hrs = hours < 10 ? `0${hours}` : hours
        const mins = minutes < 10 ? `0${minutes}` : minutes
        const secs = seconds < 10 ? `0${seconds}` : seconds
        toReturn = `${dd}:${hrs}:${mins}:${secs}`
      }
      return toReturn
    } else {
      expired.value = true
      return "This topic has already ended."
    }
  }

  /**
   * call dateRemain function every 1 second
   */
  setInterval(() => {
    dateRemain.value = getTimeRemain()
  }, 1000)

  /**
   * on cancel event
   */
  const onCancel = async () => {
    if (store.answer_id.length) {
      await store.retrieveQuestions(route.params.slug as string, route.query.token as string)
    } else store.answer = ""
    editMode.value = false
  }

  /**
   * on save event
   */
  const onSave = async () => {
    if (store.answer_id.length) {
      store.status = store.initial_answers.status
      await store.updateAnswer(nbf, route.query.token as string, "thought-leadership")
      const toast = await toastController.create({
        message: "Answer updated.",
        duration: 1500,
        position: "top",
        color: "success",
      })

      await toast.present()
    } else {
      store.status = "draft"
      await store.saveAnswer(nbf, route.query.token as string, "thought-leadership")
      const toast = await toastController.create({
        message: "Draft saved.",
        duration: 1500,
        position: "top",
        color: "success",
      })

      await toast.present()
    }
    await store.retrieveQuestions(route.params.slug as string, route.query.token as string)
    editMode.value = false
  }

  /**
   * on submit
   * save answer
   */
  const onSubmit = async () => {
    store.status = "active"
    if (store.answer_id.length) await store.updateAnswer(nbf, route.query.token as string, "thought-leadership")
    else await store.saveAnswer(nbf, route.query.token as string, "thought-leadership")
    await store.retrieveQuestions(route.params.slug as string, route.query.token as string)
    confirmation.value = false
    const toast = await toastController.create({
      message: "Answer successfully submitted.",
      duration: 1500,
      position: "top",
      color: "success",
    })

    await toast.present()

    setTimeout(() => {
      window.location.href = "/"
    }, 1000)
  }

  // opens confirmation modal
  const openModal = async () => {
    const modal = await modalController.create({
      component: verifySubmit,
      initialBreakpoint: 0.75,
      breakpoints: [0.5, 1],
    })
    modal.present()
  }

  // exits questionaire and redirects to homepage
  const exit = () => {
    window.location.href = "/"
  }

  /**
   * retrieve data
   */
  onMounted(async () => {
    expired.value = false
    if (!route.params.slug || !route.query.token) router.push("/")
    await store.retrieveQuestions(route.params.slug as string, route.query.token as string)
    await resourcesStore.retrieveThoughtLeadershipTopic()
    if (store.topic_id.length > 0 && resourcesStore.thoughtLeadership.topic_id.length > 0 && store.topic_id !== resourcesStore.thoughtLeadership.topic_id) {
      // already expire
      expired.value = true
    }
  })

  watch(
    () => router.currentRoute.value.query.submit,
    (value) => {
      if (value === "true") onSubmit()
    }
  )

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(BannerTemplate, {
      data: _unref(banner),
      "with-timer": true
    }, null, 8, ["data"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(store).topic), 1),
            (!editMode.value)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  innerHTML: replacenbsp(_unref(store).answer)
                }, null, 8, _hoisted_7))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_8, [
            (!expired.value && !editMode.value && (_unref(store).status === 'draft' || _unref(store).status === 'deny' || _unref(store).status === 'active'))
              ? (_openBlock(), _createBlock(WbButton, {
                  key: 0,
                  "native-type": "button",
                  class: "h-11",
                  type: _unref(store).answer.length ? 'default' : 'primary',
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (editMode.value = true))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("strong", null, _toDisplayString(_unref(store).answer.length ? "Edit" : "Answer"), 1)
                  ]),
                  _: 1
                }, 8, ["type"]))
              : _createCommentVNode("", true)
          ])
        ]),
        (editMode.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createVNode(WbTextArea, {
                modelValue: _unref(store).answer,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(store).answer) = $event)),
                name: "question",
                "hide-toolbar": true,
                placeholder: "Share your thoughts..."
              }, null, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(WbButton, {
                  class: "h-11 px-10",
                  type: "default",
                  onClick: onCancel
                }, {
                  default: _withCtx(() => [
                    _hoisted_11
                  ]),
                  _: 1
                }),
                _createVNode(WbButton, {
                  class: "h-11 px-10",
                  type: "primary",
                  onClick: onSave
                }, {
                  default: _withCtx(() => [
                    _hoisted_12
                  ]),
                  _: 1
                })
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", {
          class: _normalizeClass(["flex gap-5 w-full", { 'justify-end': _unref(store).status !== 'deny' }])
        }, [
          (_unref(store).status === 'deny')
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, " Your answer has been rejected. Please check for grammatical errors or add more ideas and try again. "))
            : _createCommentVNode("", true),
          _createVNode(WbButton, {
            class: "bg-white text-primary-violet shadow-xl px-10 h-12 w-full",
            type: "default",
            onClick: exit
          }, {
            default: _withCtx(() => [
              _hoisted_15
            ]),
            _: 1
          }),
          (_unref(store).status === 'draft' || _unref(store).status === 'deny')
            ? (_openBlock(), _createBlock(WbButton, {
                key: 1,
                class: "px-10 h-12 w-full",
                type: "primary",
                onClick: openModal
              }, {
                default: _withCtx(() => [
                  _createElementVNode("strong", null, _toDisplayString(_unref(store).status === "draft" ? "Submit" : "Resubmit"), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_unref(store).status !== 'draft' && _unref(store).status !== 'deny')
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, "Submitted"))
            : _createCommentVNode("", true)
        ], 2)
      ])
    ])
  ]))
}
}

})